var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "marginB20"
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.addCodeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增二维码模版")))])], 1), _vm.list.length != 0 ? _c("a-collapse", {
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("a-collapse-panel", {
      key: String(item.id),
      attrs: {
        header: item.id == -1 ? _vm.$t("二维码模板") : item.name
      }
    }, [_c("code-item", {
      attrs: {
        num: index + 1,
        dataFrom2: item,
        isEdit: item.isEdit,
        templateGroupList: _vm.templateGroupList,
        customerInsuranceId: _vm.customerInsuranceId,
        insuranceId: _vm.insuranceId
      },
      on: {
        cancel: _vm.cancelFun,
        editOk: _vm.editFun,
        ok: _vm.getInfoFun
      }
    })], 1);
  }), 1) : _c("a-empty", {
    staticStyle: {
      "margin-top": "200px"
    }
  }), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("previous");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("next", {});
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };